import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { BusinessAreaModel, IBusinessAreaModel } from './business-area.model';
import { CoreParameterModel, ILightWeightObject, ILightWeightObjectCollection } from '@fi-shared/models';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { isDefined } from '@fi-shared/utils';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class BusinessAreaService {
    DeleteBusinessAreas: any;

    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private injector: Injector,
    ) {
        this.DeleteBusinessAreas = (businessAreaIdsToDelete) =>
            this.fiBackend.fetchDataPost('Core/BusinessArea/DeleteBusinessAreas', businessAreaIdsToDelete);
    }

    GetBusinessArea(id: number) {
        return new Promise<BusinessAreaModel>((resolve, reject) => {
            if (id > 0) {
                return this.fiBackend
                    .fetchData<IBusinessAreaModel>(`Core/BusinessArea/GetBusinessArea/${id}`)
                    .then((response) => {
                        resolve(new BusinessAreaModel(response, this.injector));
                    }, reject);
            } else {
                resolve(new BusinessAreaModel(undefined, this.injector));
            }
        });
    }

    GetBusinessAreasByBusinessUnitIds(businessUnitIds: number[], applicationLanguageType?: FiApplicationLanguageType) {
        let url = 'Core/BusinessArea/GetBusinessAreasByBusinessUnitIds';
        if (isDefined(applicationLanguageType)) {
            url += `?applicationLanguageType=${applicationLanguageType}`;
        }
        return this.fiBackend.fetchDataPost<ILightWeightBusinessAreaWithUnitId[]>(url, businessUnitIds);
    }

    SaveBusinessArea(businessArea: BusinessAreaModel) {
        //Creating a new object because it looks bad in the GUI otherwise.
        const businessAreaApiModel = JSON.parse(JSON.stringify(businessArea));

        return this.fiBackend.fetchDataPost<number>('Core/BusinessArea/SaveBusinessArea', businessAreaApiModel);
    }

    getBusinessAreasListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IBusinessAreaModel>>(
            'Core/BusinessArea/GetBusinessAreasListData',
            parameter,
        );
    }

    GetBusinessAreas(businessAreaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<BusinessAreaModel[]>(
            'Core/BusinessArea/GetBusinessAreas',
            businessAreaParameterApiModel,
        );
    }

    GetBusinessAreasCount(businessAreaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<number>(
            'Core/BusinessArea/GetBusinessAreasCount',
            businessAreaParameterApiModel,
        );
    }

    GetLightWeightObjectsForLocalSearch(businessAreaParameterApiModel: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Core/BusinessArea/GetLightWeightObjectsForLocalSearch',
            businessAreaParameterApiModel,
        );
    }

    getLightWeightBusinessAreas() {
        return this.fiBackend.fetchData<ILightWeightObject[]>('Core/BusinessArea/GetLightWeightBusinessAreas');
    }

    deleteBusinessAreas(businessAreaIdsToDelete: number[]) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost('Core/BusinessArea/DeleteBusinessAreas', businessAreaIdsToDelete),
        );
    }
}
